webpackJsonp([2],{

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGOUT; });
var SET_PROFILE = "SET_PROFILE";
var LOGOUT = "LOGOUT";

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_events__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth__ = __webpack_require__(237);









__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 238));
// import ('material-design-icons-iconfont/dist/material-design-icons.css')

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_events___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_200d428b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(132);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_200d428b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18968cb7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__ = __webpack_require__(131);
var normalizeComponent = __webpack_require__(13)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18968cb7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function (_h,_vm) {var _c=_vm._c;return _c('v-toolbar',{attrs:{"app":"","dark":"","color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text ml-5"},[_vm._v("Quiz Maker")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.props.client_list,"label":_vm.props.clientSelection === '' ? 'Clients' : ''},on:{"change":_vm.props.client_selected}}),_vm._v(" "),(_vm.props.loggedIn)?_c('v-menu',{attrs:{"auto":"","offset-y":"","bottom":""}},[_c('v-avatar',{staticClass:"mr-5",attrs:{"slot":"activator"},slot:"activator"},[_c('img',{attrs:{"src":_vm.props.profile.picture}})]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":_vm.props.logout}},[_c('v-list-tile-title',[_vm._v("Logout")])],1)],1)],1):_c('v-btn',{staticClass:"mr-5",attrs:{"flat":""},on:{"click":_vm.props.login}},[_vm._v("Login")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('toolbar',{attrs:{"login":_vm.login,"logout":_vm.logout,"profile":_vm.profile,"loggedIn":_vm.loggedIn,"clientSelection":_vm.client_selection,"client_list":_vm.client_list,"client_selected":_vm.client_selected}}),_vm._v(" "),_c('v-content',[_c('v-container',[_c('router-view')],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"app":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Create__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Quiz__ = __webpack_require__(177);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */]
  }, {
    path: '/create',
    name: 'Create',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Create__["a" /* default */]
  }, {
    path: '/quiz/:id',
    name: 'Quiz',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Quiz__["a" /* default */]
  }]
}));

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d54d4ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(138);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d54d4ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizCard_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd760da8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizCard_vue__ = __webpack_require__(137);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd760da8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"pa-2",attrs:{"xs12":"","sm6":"","md4":"","xl2":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":_vm.randomColor()}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","dark":"","to":("/quiz/" + _vm.id)}},[_vm._v("Take it now")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.quizzes),function(quiz){return _c('quiz-card',{key:quiz.id,attrs:{"title":quiz.title,"description":quiz.description,"id":quiz.id}})}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.loggedIn),expression:"loggedIn"}],staticClass:"mb-5",attrs:{"absolute":"","dark":"","fab":"","bottom":"","right":"","color":"purple","to":"/create"}},[_c('v-icon',[_vm._v("add")])],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f412c07_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__(176);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f412c07_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizInformation_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88992c9c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizInformation_vue__ = __webpack_require__(171);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88992c9c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizInformation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Title","value":_vm.quiz.title},on:{"input":_vm.updateTitle}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Description","multi-line":"","value":_vm.quiz.description},on:{"input":_vm.updateDescription}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizQuestions_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b825732_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizQuestions_vue__ = __webpack_require__(173);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizQuestions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b825732_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizQuestions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-expansion-panel',{attrs:{"focusable":""}},_vm._l((_vm.quiz.questions),function(item,questionIndex){return _c('v-expansion-panel-content',{key:questionIndex,attrs:{"focusable":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(item.question))]),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-text-field',{attrs:{"label":"Question","value":item.question},on:{"input":function($event){return _vm.updateQuestionTitle($event, questionIndex)}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Points","value":item.points},on:{"input":function($event){return _vm.updateQuestionPoints($event, questionIndex)}}})],1)],1),_vm._v(" "),_c('v-container',_vm._l((item.answers),function(answer,answerIndex){return _c('v-layout',{key:answerIndex,attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-checkbox',{attrs:{"label":"Right Answer","input-value":answer.isRight,"hide-details":""},on:{"change":function($event){return _vm.updateAnswerState($event, questionIndex, answerIndex)}}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Answer","value":answer.answer},on:{"input":function($event){return _vm.updateAnswerText($event, questionIndex, answerIndex)}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){return _vm.removeAnswer({questionIndex: questionIndex, answerIndex: answerIndex})}}},[_c('v-icon',[_vm._v("remove")])],1)],1)],1)}),1),_vm._v(" "),_c('v-layout',{staticClass:"pl-2"},[(item.answers.length < 5)?_c('v-btn',{staticClass:"mt-4",attrs:{"color":"primary"},on:{"click":function($event){return _vm.addAnswer(questionIndex)}}},[_vm._v("Add Answer\n                ")]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mt-4",attrs:{"color":"red","dark":""},on:{"click":function($event){return _vm.removeQuestion(questionIndex)}}},[_vm._v("Remove Question\n                ")])],1)],1)],1)],1)}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizActions_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b3d371b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizActions_vue__ = __webpack_require__(175);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuizActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b3d371b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuizActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.quiz.questions.length < 10),expression:"quiz.questions.length < 10"}],staticClass:"mt-4",attrs:{"color":"primary"},on:{"click":_vm.addQuestion}},[_vm._v(" Add Question ")])],1),_vm._v(" "),_c('v-card-actions',[_c('b',[_vm._v("Total Points: "+_vm._s(_vm.totalPoints))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","to":"/"}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"warning"},on:{"click":_vm.reset}},[_vm._v("Reset")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"purple"},on:{"click":_vm.action}},[_vm._v(_vm._s(_vm.actionName))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"headline"},[_c('v-icon',[_vm._v("question_answer")]),_vm._v(" New Quiz\n      ")],1)])]),_vm._v(" "),_c('v-subheader',[_vm._v("Quiz Information")]),_vm._v(" "),_c('quiz-information'),_vm._v(" "),_c('v-subheader',[_vm._v("Quiz Questions")]),_vm._v(" "),_c('quiz-questions'),_vm._v(" "),_c('quiz-actions',{attrs:{"action":_vm.createQuiz,"actionName":"Create"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quiz_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb79b5fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quiz_vue__ = __webpack_require__(178);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quiz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb79b5fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quiz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.quiz)?_c('v-container',[(_vm.done)?_c('v-layout',[_c('v-flex',{attrs:{"sm12":""}},[_c('p',[_vm._v("Your score is "+_vm._s(_vm.score)+" / "+_vm._s(_vm.totalScore))]),_vm._v(" "),(_vm.mistakes.length > 0)?_c('div',[_c('h3',[_vm._v("Your Mistakes:")]),_vm._v(" "),_vm._l((_vm.mistakes),function(m,i){return _c('p',{key:i},[_vm._v("\n            question: "+_vm._s(m.question)+" "),_c('br'),_vm._v("\n            your answer: "+_vm._s(m.chosenAnswer)+" "),_c('br'),_vm._v("\n            right answer: "+_vm._s(m.rightAnswer)+"\n            "),_c('br')])})],2):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"to":"/"}},[_vm._v("Go Home")])],1)],1):_c('v-stepper',{model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-header',[_vm._l((_vm.quiz.questions.length),function(s){return [_c('v-stepper-step',{key:s,attrs:{"step":s,"complete":_vm.step > s}})]}),_vm._v(" "),_c('v-divider')],2),_vm._v(" "),_c('v-stepper-items',_vm._l((_vm.quiz.questions),function(question,i){return _c('v-stepper-content',{key:i,attrs:{"step":i + 1}},[_c('h3',[_vm._v(_vm._s(question.question))]),_vm._v(" "),_c('v-radio-group',{model:{value:(_vm.stepAnswer),callback:function ($$v) {_vm.stepAnswer=$$v},expression:"stepAnswer"}},_vm._l((question.answers),function(answer,j){return _c('v-radio',{key:j,attrs:{"label":answer.answer,"value":j}})}),1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.next($event)}}},[_vm._v("Next")])],1)}),1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__db__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(111);




var _mutations;






var state = {
  profile: {},
  loggedIn: false
};

var getters = {
  profile: function profile(_ref) {
    var _profile = _ref.profile;
    return _profile;
  },
  loggedIn: function loggedIn(_ref2) {
    var _loggedIn = _ref2.loggedIn;
    return _loggedIn;
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations__["b" /* SET_PROFILE */], function (state, profile) {
  state.loggedIn = true;
  state.profile = {
    name: profile.displayName,
    picture: profile.photoURL
  };
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* LOGOUT */], function (state) {
  state.loggedIn = false;
  state.profile = {};
}), _mutations);

var actions = {
  login: function login(store) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var provider, result;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!store.state.loggedIn) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              provider = new __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* default */].auth.GoogleAuthProvider();
              _context.prev = 3;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* default */].auth().signInWithPopup(provider);

            case 6:
              result = _context.sent;
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);

              console.log(_context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 9]]);
    }))();
  },
  logout: function logout() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* default */].auth().signOut();

            case 3:
              _context2.next = 8;
              break;

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 5]]);
    }))();
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__db__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutations__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(15);





var _mutations;







var state = {
  newQuiz: {
    title: "New Quiz",
    description: "Quiz Name",
    questions: [{
      question: "First Question",
      points: 50,
      answers: [{
        isRight: false,
        answer: "First answer"
      }, {
        isRight: false,
        answer: "Second answer"
      }, {
        isRight: false,
        answer: "Third answer"
      }]
    }]
  },

  list: [],

  quiz: null,
  client_list: [],
  client_selection: ""
};

var getters = {
  newQuiz: function newQuiz(_ref) {
    var _newQuiz = _ref.newQuiz;
    return _newQuiz;
  },
  list: function list(_ref2) {
    var _list = _ref2.list;
    return _list;
  },
  quiz: function quiz(_ref3) {
    var _quiz = _ref3.quiz;
    return _quiz;
  },
  client_list: function client_list(_ref4) {
    var _client_list = _ref4.client_list;
    return _client_list;
  },
  client_selection: function client_selection(_ref5) {
    var _client_selection = _ref5.client_selection;
    return _client_selection;
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["f" /* RESET_QUIZ */], function (state) {
  state.newQuiz = {
    title: "",
    description: "",
    questions: []
  };
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["l" /* UPDATE_INFORMATION */], function (state, info) {
  state.newQuiz.title = info.title;
  state.newQuiz.description = info.description;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["b" /* ADD_QUESTION */], function (state) {
  state.newQuiz.questions.push({
    question: "Question",
    points: 0,
    answers: []
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["m" /* UPDATE_QUESTION */], function (state, payload) {
  var question = state.newQuiz.questions[payload.questionIndex];

  question.question = payload.question;
  question.points = payload.points;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["e" /* REMOVE_QUESTION */], function (state, questionIndex) {
  if (state.newQuiz.questions.length > 1) {
    state.newQuiz.questions.splice(questionIndex, 1);
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["a" /* ADD_ANSWER */], function (state, questionIndex) {
  var answers = state.newQuiz.questions[questionIndex].answers;
  if (answers.length < 5) {
    answers.push({
      answer: "Another one!",
      isRight: false
    });
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["k" /* UPDATE_ANSWER */], function (state, payload) {
  var questionIndex = payload.questionIndex;
  var answerIndex = payload.answerIndex;
  var answerText = payload.answer;
  var isRight = payload.isRight;

  var answer = state.newQuiz.questions[questionIndex].answers[answerIndex];

  answer.isRight = payload.isRight;
  answer.answer = answerText;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["d" /* REMOVE_ANSWER */], function (state, payload) {
  var questionIndex = payload.questionIndex;
  var answerIndex = payload.answerIndex;

  var question = state.newQuiz.questions[questionIndex];

  if (question.answers.length > 1) {
    question.answers.splice(answerIndex, 1);
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["c" /* PUSH_QUIZ */], function (state, quiz) {
  state.list.push(quiz);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["g" /* RESET_QUIZ_LIST */], function (state) {
  state.list = [];
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["j" /* SET_QUIZ */], function (state, quiz) {
  state.quiz = quiz;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["i" /* SET_CLIENT_LIST */], function (state, clients) {
  state.client_list = [];
  clients.forEach(function (item, index) {
    state.client_list.splice(index, 1, item);
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations__["h" /* SET_CLIENT */], function (state, selection) {
  state.client_selection = selection;
}), _mutations);

var actions = {
  create: function create(_ref6) {
    var _this = this;

    var state = _ref6.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var user, quiz;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("Running the create async .............................................");
              user = __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* default */].auth().currentUser;

              console.log("Current user  .............................................  " + user);

              if (!user) {
                _context.next = 16;
                break;
              }

              quiz = state.newQuiz;

              if (!(!quiz.title || !quiz.description)) {
                _context.next = 7;
                break;
              }

              throw new Error("Quiz information is required!");

            case 7:
              if (!(quiz.questions.length == 0)) {
                _context.next = 9;
                break;
              }

              throw new Error("Quiz is empty!");

            case 9:

              // check if there is a question without a right answer
              quiz.questions.map(function (question) {
                if (question.answers.length == 0) {
                  throw new Error("Question: '" + question.question + "' doesn't have answers!");
                }

                var hasRightAnswer = false;

                question.answers.map(function (answer) {
                  if (answer.isRight) hasRightAnswer = true;
                });

                if (!hasRightAnswer) {
                  throw new Error("Question: '" + question.question + "' doesn't have a right answer selected!");
                }
              });

              // save to database
              console.log("Saving to database  .............................................  " + user.uid);

              _context.next = 13;
              return __WEBPACK_IMPORTED_MODULE_5__db__["a" /* default */].collection("customers/" + state.client_selection + "/quizzes").add(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.newQuiz, {
                userId: user.uid
              }));

            case 13:
              alert("Quiz created");
              _context.next = 17;
              break;

            case 16:
              alert("Unauthorized");

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  list: function list(_ref7) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutations__["g" /* RESET_QUIZ_LIST */]);
    if (state.client_selection) {
      __WEBPACK_IMPORTED_MODULE_5__db__["a" /* default */].collection("customers/" + state.client_selection + "/quizzes").onSnapshot(function (snapshot) {
        snapshot.docChanges.forEach(function (change) {
          if (change.type === "added") {
            commit(__WEBPACK_IMPORTED_MODULE_6__mutations__["c" /* PUSH_QUIZ */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
              id: change.doc.id
            }, change.doc.data()));
          }
        });
      });
    }
  },
  get: function get(_ref8, id) {
    var _this2 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var quiz;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5__db__["a" /* default */].collection("quizzes").doc(id).get();

            case 2:
              quiz = _context2.sent;


              if (quiz.exists) {
                commit(__WEBPACK_IMPORTED_MODULE_6__mutations__["j" /* SET_QUIZ */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                  id: quiz.id
                }, quiz.data()));
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  fetch_client_list: function fetch_client_list(_ref9) {
    var _this3 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var customer_docs, client_list;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_5__db__["a" /* default */].collection("customers").get();

            case 3:
              customer_docs = _context3.sent;
              client_list = [];

              console.log(customer_docs);
              customer_docs.forEach(function (doc) {
                client_list.push(doc.id);
              });
              commit(__WEBPACK_IMPORTED_MODULE_6__mutations__["i" /* SET_CLIENT_LIST */], client_list);
              console.log(client_list);
              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);

              console.error(_context3.t0);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 11]]);
    }))();
  },
  select_client: function select_client(_ref10, client) {
    var commit = _ref10.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__mutations__["h" /* SET_CLIENT */], client);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_user_mutations__ = __webpack_require__(111);





__WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* default */].auth().onAuthStateChanged(function (user) {
  if (user) {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('user/' + __WEBPACK_IMPORTED_MODULE_2__store_user_mutations__["b" /* SET_PROFILE */], user);
  } else {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('user/' + __WEBPACK_IMPORTED_MODULE_2__store_user_mutations__["a" /* LOGOUT */]);
  }
});

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_QUESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_QUESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REMOVE_QUESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ANSWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_ANSWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_ANSWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESET_QUIZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PUSH_QUIZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_QUIZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESET_QUIZ_LIST; });
/* unused harmony export ADD_QUIZ */
/* unused harmony export REMOVE_QUIZ */
/* unused harmony export UPDATE_QUIZ */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_CLIENT_LIST; });
var UPDATE_INFORMATION = "UPDATE_INFORMATION";

var ADD_QUESTION = "ADD_QUESTION";
var UPDATE_QUESTION = "UPDATE_QUESTION";
var REMOVE_QUESTION = "REMOVE_QUESTION";

var ADD_ANSWER = "ADD_ANSWER";
var REMOVE_ANSWER = "REMOVE_ANSWER";
var UPDATE_ANSWER = "UPDATE_ANSWER";

var RESET_QUIZ = "RESET_NEW_QUIZ";
var PUSH_QUIZ = "PUSH_QUIZ";
var SET_QUIZ = "SET_QUIZ";
var RESET_QUIZ_LIST = "RESET_QUIZ";

var ADD_QUIZ = "ADD_QUIZ";
var REMOVE_QUIZ = "REMOVE_QUIZ";
var UPDATE_QUIZ = "UPDATE_QUIZ";

var SET_CLIENT = "SET_CLIENT";
var SET_CLIENT_LIST = "SET_CLIENT_LIST";

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_auth__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__firebase_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_firestore__ = __webpack_require__(197);




__WEBPACK_IMPORTED_MODULE_0__firebase_app__["default"].initializeApp({
  apiKey: "AIzaSyB_UfOy9uRdArhuIq4DaqFhWeX-pgSJHP8",
  authDomain: "cgcaci21.firebaseapp.com",
  databaseURL: "https://cgcaci21.firebaseio.com",
  projectId: "cgcaci21",
  storageBucket: "cgcaci21.appspot.com",
  messagingSenderId: "595065889262",
  appId: "1:595065889262:web:90fac884b0452a89b56eff",
  measurementId: "G-M0K5LQT39Q"
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__firebase_app__["default"]);

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Toolbar__ = __webpack_require__(130);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  components: { Toolbar: __WEBPACK_IMPORTED_MODULE_2__components_Toolbar__["a" /* default */] },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', {
    profile: 'profile',
    loggedIn: 'loggedIn'

  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('quiz', {
    client_list: 'client_list',
    client_selection: 'client_selection'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', {
    login: 'login',
    logout: 'logout'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])("quiz", {
    fetch_client_list: "fetch_client_list",
    select_client: "select_client",
    list: "list"

  }), {
    client_selected: function client_selected(data) {
      console.log(data);
      this.select_client(data);
      this.list();
    }
  })
});

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_quiz_QuizCard__ = __webpack_require__(136);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',

  components: {
    QuizCard: __WEBPACK_IMPORTED_MODULE_2__components_quiz_QuizCard__["a" /* default */]
  },

  created: function created() {
    this.findQuizzes();
    this.fetch_client_list();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', {
    loggedIn: 'loggedIn'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('quiz', {
    quizzes: 'list',
    client_list: 'client_list',
    client_selection: 'client_selection'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('quiz', {
    findQuizzes: 'list',
    fetch_client_list: "fetch_client_list"
  }))
});

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'quiz-card',
  props: ['title', 'description', 'id'],
  methods: {
    randomColor: function randomColor() {
      var colorsList = ["grey", "deep-orange", "brown", "blue-grey", "orange", "green", "cyan", "teal", "blue", "indigo", "pink", "red", "purple"];

      var rand = Math.floor(Math.random() * colorsList.length);

      return colorsList[rand];
    }
  }
});

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_quiz_QuizInformation__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_quiz_QuizQuestions__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_quiz_QuizActions__ = __webpack_require__(174);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'create-quiz',

  components: {
    QuizInformation: __WEBPACK_IMPORTED_MODULE_4__components_quiz_QuizInformation__["a" /* default */],
    QuizQuestions: __WEBPACK_IMPORTED_MODULE_5__components_quiz_QuizQuestions__["a" /* default */],
    QuizActions: __WEBPACK_IMPORTED_MODULE_6__components_quiz_QuizActions__["a" /* default */]
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('quiz', {
    create: 'create'
  }), {
    createQuiz: function createQuiz() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  _this.create();
                  _this.$router.push('/');
                } catch (error) {
                  alert(error);
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_quiz_mutations__ = __webpack_require__(41);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "quiz-information",

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('quiz', {
    quiz: 'newQuiz'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('quiz', {
    updateInformation: __WEBPACK_IMPORTED_MODULE_2__store_quiz_mutations__["l" /* UPDATE_INFORMATION */]
  }), {
    updateTitle: function updateTitle(value) {
      this.updateInformation({
        title: value,
        description: this.quiz.description
      });
    },
    updateDescription: function updateDescription(value) {
      this.updateInformation({
        description: value,
        title: this.quiz.title
      });
    }
  })
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_quiz_mutations__ = __webpack_require__(41);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'quiz-questions',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('quiz', {
    quiz: 'newQuiz'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('quiz', {
    addAnswer: __WEBPACK_IMPORTED_MODULE_2__store_quiz_mutations__["a" /* ADD_ANSWER */],
    updateQuestion: __WEBPACK_IMPORTED_MODULE_2__store_quiz_mutations__["m" /* UPDATE_QUESTION */],
    removeQuestion: __WEBPACK_IMPORTED_MODULE_2__store_quiz_mutations__["e" /* REMOVE_QUESTION */],
    removeAnswer: __WEBPACK_IMPORTED_MODULE_2__store_quiz_mutations__["d" /* REMOVE_ANSWER */],
    updateAnswer: __WEBPACK_IMPORTED_MODULE_2__store_quiz_mutations__["k" /* UPDATE_ANSWER */]
  }), {
    updateAnswerText: function updateAnswerText(value, questionIndex, answerIndex) {
      this.updateAnswer({
        answer: value,
        isRight: this.quiz.questions[questionIndex].answers[answerIndex].isRight,

        questionIndex: questionIndex,
        answerIndex: answerIndex
      });
    },
    updateAnswerState: function updateAnswerState(value, questionIndex, answerIndex) {
      this.updateAnswer({
        isRight: value,
        answer: this.quiz.questions[questionIndex].answers[answerIndex].answer,
        questionIndex: questionIndex,
        answerIndex: answerIndex
      });
    },
    updateQuestionTitle: function updateQuestionTitle(value, questionIndex) {
      this.updateQuestion({
        question: value,
        points: this.quiz.questions[questionIndex].points,
        questionIndex: questionIndex
      });
    },
    updateQuestionPoints: function updateQuestionPoints(value, questionIndex) {
      // test if the input does not contain a valid number or the number is negative
      var points = parseInt(value);
      if (isNaN(points) || points < 0) return; // cancel triggering the mutation

      this.updateQuestion({
        question: this.quiz.questions[questionIndex].question,
        points: points,
        questionIndex: questionIndex
      });
    }
  })
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_quiz_mutations__ = __webpack_require__(41);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'quiz-actions',
  props: ['action', 'actionName'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('quiz', { quiz: 'newQuiz' }), {
    totalPoints: function totalPoints() {
      return this.quiz.questions.reduce(function (curr, question) {
        return parseInt(question.points) + curr;
      }, 0);
      // we used parseInt because the value coming from the input is a string.
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('quiz', {
    addQuestion: __WEBPACK_IMPORTED_MODULE_2__store_quiz_mutations__["b" /* ADD_QUESTION */],
    reset: __WEBPACK_IMPORTED_MODULE_2__store_quiz_mutations__["f" /* RESET_QUIZ */]
  }))
});

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'quiz',

  created: function created() {
    // get the quiz using the id passed in url params
    this.getQuiz(this.$route.params.id);
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('quiz', { quiz: 'quiz' }), {
    totalScore: function totalScore() {
      return this.quiz.questions.reduce(function (curr, question) {
        return curr + question.points;
      }, 0);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('quiz', { getQuiz: 'get' }), {
    next: function next() {
      // check if the answer is correct
      if (this.stepAnswer == null) return;

      var question = this.quiz.questions[this.step - 1];
      var answer = question.answers[this.stepAnswer];

      if (answer.isRight) this.score += question.points;else {
        // add mistake to the mistakes array
        this.mistakes.push({
          question: question.question,
          rightAnswer: question.answers.find(function (answer) {
            return answer.isRight;
          }).answer,
          chosenAnswer: answer.answer
        });
      }

      // check if the quiz is done
      if (this.step < this.quiz.questions.length) {
        this.step++;
        this.stepAnswer = null;
      } else {
        console.log('here');
        this.done = true;
      }
    }
  }),

  data: function data() {
    return {
      step: 1,
      score: 0,
      stepAnswer: null,
      done: false,
      mistakes: []
    };
  }
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_user__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_quiz__ = __webpack_require__(236);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    awesome: true
  },

  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__store_user__["a" /* default */],
    quiz: __WEBPACK_IMPORTED_MODULE_3__store_quiz__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(42);


var db = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* default */].firestore();

/* harmony default export */ __webpack_exports__["a"] = (db);

/***/ })

},[112]);


// WEBPACK FOOTER //
// static/js/app.f9c48bb4d817e4dbc4e0.js